"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAmbigiousISOCountryCodeToAlpha2 = transformAmbigiousISOCountryCodeToAlpha2;
const i18n_iso_countries_1 = require("i18n-iso-countries");
function transformAmbigiousISOCountryCodeToAlpha2(ambigiousCountryCode) {
    const iso2 = (0, i18n_iso_countries_1.alpha3ToAlpha2)(ambigiousCountryCode);
    if (iso2) {
        return iso2.toLowerCase();
    }
    switch (ambigiousCountryCode) {
        // outdated ISO3 codes
        case "ROM":
            return "ro";
        // everything else
        default:
            return ambigiousCountryCode;
    }
}
//# sourceMappingURL=transformAmbigiousISOCountryCodeToAlpha2.js.map